export default function FallbackAnimation() {
    return (
      <>
      </>
    );
  }
  